module.exports = __webpack_public_path__ + "img/ashburt.72e85a9c.jpg";